import { createReducer, on } from "@ngrx/store";
import { ProviderOutput } from "../../../models/load_curves.model";
import { StateTypes } from "../../../models/state-types";
import { loadCurvesActions } from "../load_curves.actions";

export interface ProviderState {
    providers: ProviderOutput[]|null,
    providers_state: StateTypes

    single_provider: ProviderOutput|null,
    single_provider_state: StateTypes
}

export const initialState: ProviderState = {
    providers: null,
    providers_state: 'pending',

    single_provider: null,
    single_provider_state: 'pending'
};

export const providerReducer = createReducer(
    initialState,

    on(loadCurvesActions.getProviders, (state) => ({
        ...state,
        providers: null,
        providers_state: 'loading' as const
    })),
    on(loadCurvesActions.getProvidersSuccess, (state, {data}) => ({
        ...state,
        providers: data,
        providers_state: 'loaded' as const
    })),
    on(loadCurvesActions.getProvidersFail, (state) => ({
        ...state,
        providers: null,
        providers_state: 'error' as const
    }))
)